import { render, staticRenderFns } from "./userForm.vue?vue&type=template&id=190e09c0&scoped=true"
import script from "./userForm.vue?vue&type=script&lang=js"
export * from "./userForm.vue?vue&type=script&lang=js"
import style0 from "./userForm.vue?vue&type=style&index=0&id=190e09c0&prod&scoped=true&lang=css"
import style1 from "./userForm.vue?vue&type=style&index=1&id=190e09c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190e09c0",
  null
  
)

export default component.exports